// Core React Imports
import React from "react";
import WidgetIconFive from "../../../icons/widget-icon-five/WidgetIconFive";
import ConstantsImages from "../../../../constants/ConstantsImages";
import ConstantsTexts from "../../../../constants/ConstantsTexts";

// Local Imports
import "./WidgetCustomFooterItemSecond.css";

const WidgetCustomFooterItemSecond = ({ defaultText = ConstantsTexts.CODE_166, selectedText = ConstantsTexts.CODE_34, isSelected = false, onCloseClick, onSelectedClick }) => {
  const currentText = isSelected ? selectedText : defaultText;

  const handleCloseClick = (e) => {
    e.stopPropagation();

    if (onCloseClick) {
      onCloseClick();
    }
  };

  const handleSelectedClick = (e) => {
    e.stopPropagation();

    if (onSelectedClick) {
      onSelectedClick();
    }
  };

  if (isSelected) {
    return (
      <div className="custom-footer-item-second-split">
        {/* First half - current design */}
        <div className="custom-footer-item-second selected" onClick={handleSelectedClick}>
          <WidgetIconFive iconProp={ConstantsImages.CHECKMARK_IMAGE} widthIconProp="1.4rem" heightIconProp="1.5rem" />
          <div className="custom-footer-text-second selected">{currentText}</div>
        </div>

        {/* Second half - grey background with close icon */}
        <div className="custom-footer-item-second-close" onClick={handleCloseClick}>
          <WidgetIconFive iconProp={ConstantsImages.CLOSE_4_IMAGE} widthIconProp="1.4rem" heightIconProp="1.5rem" />
        </div>
      </div>
    );
  }

  return (
    <div className="custom-footer-item-second default">
      <div className="custom-footer-text-second default">{currentText}</div>
    </div>
  );
};

export default WidgetCustomFooterItemSecond;
